import {TimeUnit, useTimeUnitTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {CountdownSize} from './Countdown';

const UnitDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Value = styled.span`
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px16};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const Unit = styled.span`
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px10};
  opacity: 0.5;
  text-transform: uppercase;
  letter-spacing: 0.8px;
`;

export interface CountdownUnitProps {
  value: string;
  unit: TimeUnit;
  'data-testid': string;
  size?: CountdownSize;
  light?: boolean;
}

export function CountdownUnit({unit, value, ...rest}: CountdownUnitProps) {
  const timeFormat = useTimeUnitTranslation('short');

  return (
    <UnitDisplay {...rest}>
      <Value>{value}</Value>
      <Unit>{timeFormat[unit]}</Unit>
    </UnitDisplay>
  );
}
